// 가이드라인 _ 공통 스크립트
const sticky_container = document.getElementById('tables-of-contents-container');
const sticky_object = document.getElementById('tables-of-contents');

const sticky_object_offset_top = sticky_object.offsetTop - 100; // + sticky_contaibonner.clientHeight

// 높이 지정해주기.
sticky_container.setAttribute("style", `display:block;height: ${sticky_container.clientHeight}px;`);

sticky_object.addEventListener('mouseenter', function( event ) {
    sticky_object.classList.add('on');
});

sticky_object.addEventListener('click', function( event ) {
    if(sticky_object_offset_top < window.scrollY) sticky_object.classList.toggle('on');
});

sticky_object.addEventListener('mouseleave', function( event ) {
    if(sticky_object_offset_top < window.scrollY) sticky_object.classList.remove('on');
});

window.addEventListener('scroll', function(e) {
    // table of contents
    if( sticky_object_offset_top < window.scrollY && !sticky_object.classList.contains('sticky') ) {
        sticky_object.classList.add('sticky');
        sticky_object.setAttribute('style', `width: ${sticky_container.clientWidth}px;`);
        sticky_object.classList.remove('on'); // 최초 1회 강제로 on class 지우기.
    } else if( sticky_object_offset_top > window.scrollY && sticky_object.classList.contains('sticky') ) {
        sticky_object.classList.remove('sticky');
        sticky_object.setAttribute('style', `width: auto;`);
        sticky_object.classList.add('on'); // 최초 1회 강제로 on class Add.
    }
});

// image modal
let imageTagList = document.querySelectorAll('img.lightbox');
let body_object = document.querySelector('body');
for(let i=0;i<imageTagList.length;i++){
    imageTagList[i].addEventListener('click',function(){
        let modal = document.getElementById('img-modal');
        let content = document.getElementById('img-modal-content');
        modal.style.display = 'block';
        content.src = this.src;
        body_object.style.overflowY = 'hidden';
    });
}

let modal_close_obj = document.getElementById('img-modal');
modal_close_obj.addEventListener('click', function( event ) {
    let modal = document.getElementById('img-modal');
    let content = document.getElementById('img-modal-content');
    modal.style.display="none";
    content.src = '';
    body_object.style.overflowY = 'auto';
});



// WEBPACK FOOTER //
// ./src/components/quickguide/common.js